import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=5e700c8c&scoped=true"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"
import style0 from "./Accident.vue?vue&type=style&index=0&id=5e700c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e700c8c",
  null
  
)

export default component.exports